import { StorageItems } from '@/entities/storage.items';

enum storeNamespaces {
    MAIN_MODULE = 'mainModule',
    TURN_IN_MODULE = 'turnInModule',
}
enum mainModuleStoreActionNames {
    RESET_ALL = 'resetAll',
    SET_WIDGETS_INFO = 'setWidgetsInfo',
    SET_API_ENDPOINTS = 'setApiEndpoints',
}
enum mainModuleStoreGetterNames {
    PAGE_ATTRIBUTES_MAP = 'pageAttributesMap',
    PAGE_CONTEXT = 'pageContext',
    STORASGE_ITEMS = 'storageItems',
    WIDGETS_INFO = 'widgetsInfo',
    MESSAGES = 'messages',
    API_ENDPOINTS = 'apiEndpoints',
    DEVICE = 'device',
    IS_MOBILE_VIEW = 'isMobileView',
    IS_DESKTOP_VIEW = 'isDesktopView',
}

export {
  storeNamespaces,
  mainModuleStoreActionNames,
  mainModuleStoreGetterNames,
};
